// extracted by css-extract-rspack-plugin
export default {"wysiwyg":"product-detail-fragment__Wysiwyg_wysiwyg__IaBpx"};